// extracted by mini-css-extract-plugin
module.exports = {"bpMedium":"(min-width: 768px)","card":"styles-module--card---kk_L","cardInner":"styles-module--cardInner--3nCSJ"};